// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"userMenu_menuButton__zHCv2","tip":"userMenu_tip__102xG","menuContent":"userMenu_menuContent__ikUX7","Link":"userMenu_Link__23goz"};